import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {RestaurantServiceService} from '../../../restaurant/restaurant-service.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-menu',
  templateUrl: './add-menu.component.html',
  styleUrls: ['./add-menu.component.scss']
})
export class AddMenuComponent implements OnInit {
  private resID: number;
  private menuName: string;
  private disableSubmit: boolean;
  private menuObj: { 'Name': '',
    'RestroId': 0};
  constructor(private router: Router,
              private route: ActivatedRoute,
              private restaurantServices: RestaurantServiceService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.resID = Number(this.route.snapshot.paramMap.get('id'));
    this.disableSubmit = false;
    this.menuObj = {
      'Name': '',
      'RestroId': 0
    };
    console.log('restaurantRouterId', this.resID);
  }
  onSubmit() {
    // @ts-ignore
    this.menuObj.Name = this.menuName;
    // @ts-ignore
    this.menuObj.RestroId = this.resID;
    this.disableSubmit = true;
    this.restaurantServices.setRestaurantMenu(this.menuObj).subscribe(response => {
      // if ( response.HasErrors) {
      //   this.disableSubmit = false;
      //   this.toastr.error('Failed to add menu try again', 'Error');
      // } else {
        this.toastr.success('Menu added successfully!', 'Success');
        this.router.navigateByUrl('/menu/' + this.resID);
      // }
    });
    console.log('menuName', this.menuName, this.menuObj);
  }
}
